import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  InterceptorUtil,
  LoggerService,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
  normalizeHttpError,
} from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GgFaq } from '../../model/gg-faq.model';
import { FaqAdapter } from './faq.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccFaqAdapter implements FaqAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  load(id: string): Observable<GgFaq> {
    const url = this.occEndpoints.buildUrl('faq', {
      urlParams: { id },
    });
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    return this.http
      .get<GgFaq>(url, { headers })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
